import { AreaHfb, Media, AREA_OPTIONS } from "../types/media";

export const mapUniqueMediaAreas = (medias: (Media & AreaHfb)[]): string[] =>
  [
    ...new Set(
      (medias ?? [])
        .map((media: Media & AreaHfb) => media.areaHfb?.trim())
        .filter(
          (areaHfb: string | undefined): areaHfb is string =>
            !!areaHfb &&
            (/^HFB \d{2}$/.test(areaHfb) ||
              AREA_OPTIONS.some((area) => area.value === areaHfb))
        )
    ),
  ].sort();
